import axios from "@/lib/axios";

export const getAllSponsorships = async () => {
  const { data } = await axios.get("/sponsorships");
  return data.data;
};

export const getSponsorship = async (id) => {
  const { data } = await axios.get(`/sponsorships/${id}`);
  return data.data;
};

export const createSponsorship = async (sponsorshipData) => {
  const { data } = await axios.post("/sponsorships", sponsorshipData);
  return data.data;
};

export const updateSponsorship = async ({ id, ...sponsorshipData }) => {
  const { data } = await axios.put(`/sponsorships/${id}`, sponsorshipData);
  return data.data;
};

export const deleteSponsorship = async (id) => {
  const { data } = await axios.delete(`/sponsorships/${id}`);
  return data.data;
};

export const recordSponsorshipPayment = async ({ id, amount }) => {
  const { data } = await axios.post(`/sponsorships/${id}/record-payment`, {
    amount,
  });
  return data.data;
};
